import { render } from "./Scheduleofassessmentmanagement.vue?vue&type=template&id=3d38f5ee&scoped=true"
import script from "./Scheduleofassessmentmanagement.js?vue&type=script&lang=js"
export * from "./Scheduleofassessmentmanagement.js?vue&type=script&lang=js"

import "./Scheduleofassessmentmanagement.vue?vue&type=style&index=0&id=3d38f5ee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d38f5ee"]])

export default __exports__